module.exports = __FOREMAN_VENDOR__PATTERNFLY_REACT_CORE__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__PATTERNFLY_REACT_CORE__"
// module id = @patternfly/react-core
// module chunks = 0